import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-[#2F5890] text-center md:text-left" data-id="element-50">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-51">
        <div className="flex items-center gap-2" data-id="element-52">
          <img src="https://cdn.magicpatterns.com/uploads/tLzfQ1BmUxeV3E8dAejsqi/PH_KO_logo.png" alt="ePluribus Health Logo" className="h-8 w-auto" data-id="element-53" />
        </div>

        <div className="text-sm text-white/40" data-id="element-54">
          © {new Date().getFullYear()} ePluribus Health. All rights reserved.
        </div>
      </div>
    </footer>;
}